<div class="login-container">
    <!-- Left brand panel -->
    <div class="brand-panel">
        <!-- Animated floating particles -->
        <div class="particles">
            <span class="particle p1"></span>
            <span class="particle p2"></span>
            <span class="particle p3"></span>
            <span class="particle p4"></span>
            <span class="particle p5"></span>
            <span class="particle p6"></span>
        </div>

        <!-- Animated rings -->
        <div class="ring ring-1"></div>
        <div class="ring ring-2"></div>
        <div class="ring ring-3"></div>

        <div class="brand-content">
            <div class="logo-wrapper">
                <img
                    src="./../../assets/icons/bp-color-logo.png"
                    alt="Blumepress"
                    class="brand-logo"
                />
            </div>

            <p class="brand-tagline">
                Your all-in-one PR solution, reimagined.
            </p>

            <!-- Feature highlights -->
            <div class="features">
                <div class="feature-item">
                    <mat-icon class="feature-icon">speed</mat-icon>
                    <div class="feature-text">
                        <strong>Fast Publishing</strong>
                        <span>Publish in seconds, reach millions</span>
                    </div>
                </div>
                <div class="feature-item">
                    <mat-icon class="feature-icon">analytics</mat-icon>
                    <div class="feature-text">
                        <strong>Real-Time Analytics</strong>
                        <span>Track engagement as it happens</span>
                    </div>
                </div>
                <div class="feature-item">
                    <mat-icon class="feature-icon">language</mat-icon>
                    <div class="feature-text">
                        <strong>Global Reach</strong>
                        <span>Multi-language pressrooms</span>
                    </div>
                </div>
            </div>

            <!-- Trust & compliance badges -->
            <div class="trust-badges">
                <div class="badge" matTooltip="GDPR Compliant">
                    <mat-icon>verified_user</mat-icon>
                    <span>GDPR</span>
                </div>
                <div class="badge" matTooltip="256-bit SSL Encryption">
                    <mat-icon>lock</mat-icon>
                    <span>SSL</span>
                </div>
                <div class="badge" matTooltip="SOC 2 Compliant">
                    <mat-icon>shield</mat-icon>
                    <span>SOC 2</span>
                </div>
                <div class="badge" matTooltip="99.9% Uptime SLA">
                    <mat-icon>check_circle</mat-icon>
                    <span>99.9%</span>
                </div>
            </div>
        </div>

        <div class="brand-footer">
            <span>
                &copy; {{ currentYear }} Blumepress. All rights reserved.
            </span>
        </div>
    </div>

    <!-- Right form panel -->
    <div class="form-panel">
        <mat-progress-bar
            *ngIf="isloading"
            mode="indeterminate"
            color="primary"
            class="progress-bar"
        ></mat-progress-bar>

        <div class="form-wrapper">
            <div class="form-content">
                <h2 class="form-title">Welcome back</h2>
                <p class="form-subtitle">
                    Sign in to continue to your PR dashboard
                </p>

                <div class="alert-banner" *ngIf="bpAlert">
                    <mat-icon class="alert-icon">error_outline</mat-icon>
                    <span>{{ messageAlert }}</span>
                </div>

                <form class="login-form" [style.opacity]="opacityLevel">
                    <mat-form-field class="full-width" appearance="outline">
                        <mat-label>Email address</mat-label>
                        <mat-icon matPrefix>email</mat-icon>
                        <input
                            matInput
                            placeholder="you@company.com"
                            [formControl]="loginFormControl"
                            #userEmail
                            required
                        />
                        <mat-error
                            *ngIf="
                                loginFormControl.hasError('email') &&
                                !loginFormControl.hasError('required')
                            "
                        >
                            Please enter a valid email address
                        </mat-error>
                        <mat-error
                            *ngIf="loginFormControl.hasError('required')"
                        >
                            Email is
                            <strong>required</strong>
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="full-width" appearance="outline">
                        <mat-label>Password</mat-label>
                        <mat-icon matPrefix>lock</mat-icon>
                        <input
                            matInput
                            placeholder="Enter your password"
                            #userPassword
                            required
                            [type]="hidePassword ? 'password' : 'text'"
                        />
                        <button
                            mat-icon-button
                            matSuffix
                            type="button"
                            (click)="hidePassword = !hidePassword"
                            tabindex="-1"
                        >
                            <mat-icon>
                                {{
                                    hidePassword
                                        ? 'visibility_off'
                                        : 'visibility'
                                }}
                            </mat-icon>
                        </button>
                    </mat-form-field>

                    <div class="form-options">
                        <mat-checkbox color="primary">Remember me</mat-checkbox>
                        <a class="forgot-link" (click)="forgotPassword()">
                            Forgot password?
                        </a>
                    </div>

                    <button
                        mat-raised-button
                        class="login-btn"
                        (click)="login(userEmail.value, userPassword.value)"
                        [disabled]="isloading"
                    >
                        <span *ngIf="!isloading">Log in</span>
                        <mat-spinner
                            *ngIf="isloading"
                            diameter="22"
                            color="accent"
                        ></mat-spinner>
                    </button>
                </form>

                <div class="divider-row">
                    <span class="divider-line"></span>
                    <span class="divider-text">
                        Sign up or log in using Google
                    </span>
                    <span class="divider-line"></span>
                </div>

                <div class="google-signin">
                    <div #googleBtn class="google-btn"></div>
                    <p class="google-unavailable" *ngIf="googleUnavailable">
                        Google sign-in is currently unavailable.
                    </p>
                </div>

                <p class="form-footer-text">
                    Protected by enterprise-grade security
                    <mat-icon class="inline-icon">lock</mat-icon>
                </p>
            </div>
        </div>
    </div>
</div>
